<template>
  <nav class="navbar navbar-taskbar pt-1 pb-0 px-0 border-top-1 fixed-bottom d-flex align-items-center justify-content-around d-lg-none">
    <router-link
      :to="`/business-plan/${userId}/prospect`"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%;"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-phone"></i>
      </span>
      <span class="small">
        Prospect
      </span>
    </router-link>
    <router-link
      :to="`/business-plan/${userId}/tasks`"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%;"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-check-square"></i>
      </span>
      <span class="small">
        Tasks
      </span>
    </router-link>
    <router-link
      :to="`/business-plan/${userId}/report`"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%;"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-line-chart"></i>
      </span>
      <span class="small">
        Report
      </span>
    </router-link>
    <router-link
      :to="`/business-plan/${userId}/activity`"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%;"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-th-list"></i>
      </span>
      <span class="small">
        Activity
      </span>
    </router-link>
  </nav>
</template>

<script>
export default {
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  mounted () {
    $('body').prepend($(this.$el))
  }
}
</script>